<div class="gender-form">
    <mat-checkbox [(ngModel)]="model.h">Hingst</mat-checkbox>
    <mat-checkbox [(ngModel)]="model.s">Sto</mat-checkbox>
    <mat-checkbox [(ngModel)]="model.v">Valack</mat-checkbox>
</div>
